/* eslint-disable react/forbid-prop-types */
import { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

import DataTable from '../../juristec-ui/core/DataTable/DataTable';
import TablePagination from '../../juristec-ui/core/TablePagination';
import Badge from '../../juristec-ui/core/Badge';
import Tooltip from '../../juristec-ui/core/Tooltip';
import IconButton from '../../juristec-ui/core/IconButton';
import Popover from '../../juristec-ui/core/Popover';
import List from '../../juristec-ui/core/List';
import ListItem from '../../juristec-ui/core/ListItem';
import TableFilters from '../Popovers/TableFilters';

import { formatDateTime } from '../../juristec-ui/utils/functions/lab';

import {
  ClosedLock,
  Edit,
  ExpandMore,
  MoreVert,
  Trash,
  Users,
  AddUser,
  Report,
  Credentials,
  Antecipei,
  BennerSimpleGray,
  Message,
  InactivateFile,
  RestoreFile,
  VirtualAssistant,
  LegalOne,
  Key,
  OpenIdConnect,
  Info,
} from '../../juristec-ui/icons';

import {
  IconFlipWrapper,
  MainContainer,
  TableOverFlow,
  PlanLabel,
  PlanLabelExtra,
  CollapsibleContainer,
  ExtraInfos,
  ExtraItens,
  Options,
  Ged,
} from './styled/InstanceTable.styled';

const emptyFunc = () => {};
const emptyArr = [];
const emptyObj = {};

/** Lists all instances and their options */
const InstanceTable = ({
  instances = emptyArr,
  handleBlock = emptyFunc,
  handleEdit = emptyFunc,
  handleAddTokens = emptyFunc,
  handleDelete = emptyFunc,
  handleAddUser = emptyFunc,
  handleOnboarding = emptyFunc,
  handleRequestApiCredentials = emptyFunc,
  handleAddAntecipei = emptyFunc,
  handleAddBenner = emptyFunc,
  handleMessage = emptyFunc,
  handleApiGedRegister = emptyFunc,
  handleAllowL1Reports = emptyFunc,
  handleRemovePasswords = emptyFunc,
  //
  openUsersModal = emptyFunc,
  handleInformation = emptyFunc,
  //
  userIsAdmin = false,
  userIsSupport = false,
  plans = emptyObj,
  //
  filterText = '',
  handleDeactivateCustomerReports = emptyFunc,
  handleReactivateCustomerReports = emptyFunc,
}) => {
  const theme = useTheme();

  const [page, setPage] = useState(0);
  const [showExtra, setShowExtra] = useState({});
  const [rowData, setRowData] = useState(instances);
  const [filters, setFilters] = useState({
    name: { isOpen: false, selected: [], isDirty: false },
    plan: { isOpen: false, selected: [], isDirty: false },
    disabled: { isOpen: false, selected: [], isDirty: false },
    operationalStatus: { isOpen: false, selected: [], isDirty: false },
  });

  const filteredInstances = useMemo(() => instances.filter((instance) => {
    const nameFilter = filters.name.selected;
    const planFilter = filters.plan.selected;
    const disabledFilter = filters.disabled.selected;
    const operationalStatusFilter = filters.operationalStatus.selected;

    const matchesName = nameFilter.length === 0 || nameFilter.includes(instance.name);

    const matchesPlan = planFilter.length === 0 || planFilter.includes(instance.plan);

    const matchesDisabled = disabledFilter.length === 0
      || disabledFilter.includes(instance.disabled);

    const matchesOperationalStatus = operationalStatusFilter.length === 0
      || operationalStatusFilter.includes(instance.operationalStatus);

    return (
      matchesName && matchesPlan && matchesDisabled && matchesOperationalStatus
    );
  }), [instances, filters]);

  const handleExtraContent = (toggle, key) => {
    setShowExtra((old) => ({
      ...old,
      [key]: toggle,
    }));
  };

  const InstanceOptions = ({ instance }) => {
    const usersModal = (e) => {
      e.stopPropagation();
      openUsersModal(instance);
    };
    // const addOnboardingReport = (e) => {
    //   e.stopPropagation();
    //   handleOnboarding(instance);
    // };
    // const requestL1extractorCredentials = (e) => {
    //   e.stopPropagation();
    //   handleRequestApiCredentials(instance);
    // };
    const requestInstanceInformation = (e) => {
      e.stopPropagation();
      handleInformation(instance);
    };

    return (
      <Options>
        <>
          <Tooltip text="Usuários">
            <IconButton variant="pattern" shape="rounded" color="primary" onClick={usersModal}>
              <Users />
            </IconButton>
          </Tooltip>
          {(userIsSupport || userIsAdmin) && (
            <Tooltip text="Informações">
              <IconButton variant="pattern" shape="rounded" color="primary" onClick={requestInstanceInformation}>
                <Info />
              </IconButton>
            </Tooltip>
          )}
          {/* Removendo as opções relacionadas ao data extractor - 10/06/2026 */}
          {/* {userIsAdmin && process.env.REACT_APP_FIREBASE_PROJECT_LABEL === 'legalone-analytics' && (
            instance.l1extractor_credentials ? (
              <Tooltip text="Relatório de Onboarding">
                <IconButton variant="pattern" shape="rounded" color="primary" onClick={addOnboardingReport}>
                  <Report />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip text="Requisitar credenciais (Extrator)">
                <IconButton variant="pattern" shape="rounded" color="primary" onClick={requestL1extractorCredentials}>
                  <Credentials />
                </IconButton>
              </Tooltip>
            )
          )} */}
        </>
      </Options>
    );
  };

  const InstanceMoreOptions = ({ instance }) => {
    const [showOptions, setShowOptions] = useState(false);

    const blockInstance = (e) => {
      e.stopPropagation();
      handleBlock(instance);
    };

    const editInstace = (e) => {
      e.stopPropagation();
      handleEdit(instance);
    };

    const addTokens = (e) => {
      e.stopPropagation();
      handleAddTokens(instance);
    };

    const deleteInstance = (e) => {
      e.stopPropagation();
      handleDelete(instance);
    };

    const addUser = (e) => {
      e.stopPropagation();
      handleAddUser(instance);
    };

    const addAntecipei = (e) => {
      e.stopPropagation();
      handleAddAntecipei(instance);
    };

    const addBenner = (e) => {
      e.stopPropagation();
      handleAddBenner(instance);
    };

    const togglePopover = (e) => {
      e.stopPropagation();
      setShowOptions((o) => !o);
    };

    const message = (e) => {
      e.stopPropagation();
      handleMessage(instance);
    };

    const registerApiGed = (e) => {
      e.stopPropagation();
      handleApiGedRegister(instance, Boolean(instance?.apiGedCredentials));
    };

    const deactivateCustomerReports = (e) => {
      e.stopPropagation();
      handleDeactivateCustomerReports(instance);
    };

    const reactivateCustomerReports = (e) => {
      e.stopPropagation();
      handleReactivateCustomerReports(instance);
    };

    const allowL1Reports = (e) => {
      e.stopPropagation();
      handleAllowL1Reports(instance);
    };

    const removePasswords = (e) => {
      // Removido pois bloqueia o sso do usuario
      e.stopPropagation();
      handleRemovePasswords(instance);
    };

    return (
      <Popover closePopover={() => setShowOptions(false)} open={showOptions}>
        <Popover.Action>
          {(userIsAdmin || userIsSupport) && (
            <Tooltip text="Mais opções">
              <IconButton variant="pattern" shape="rounded" onClick={togglePopover}>
                <MoreVert aria-hidden="true" type="button" data-dismiss="modal" aria-label="Close" />
              </IconButton>
            </Tooltip>
          )}
        </Popover.Action>
        <Popover.Content>
          <List>
            {userIsAdmin && (
              <>
                <ListItem onClick={addUser}>
                  <AddUser />
                  {`${!instance.loginProvider?.length > 0 ? 'Adicionar' : 'Provisionar'} Usuário`}
                </ListItem>
                <ListItem onClick={addAntecipei}>
                  <Antecipei width="18px" height="18px" />
                  Criar Relatório Antecipei
                </ListItem>
                {process.env.REACT_APP_FIREBASE_PROJECT_LABEL === 'benner-metrics' && (
                  <ListItem onClick={addBenner}>
                    <BennerSimpleGray width="18px" height="18px" style={{ fill: '#9a9a9a' }} />
                    Criar Relatório Benner
                  </ListItem>
                )}
              </>
            )}
            {(process.env.REACT_APP_FIREBASE_PROJECT_LABEL !== 'benner-metrics'
              && (instance.operationalStatus !== 'Cancelado'
              && !instance.disabled)) && (
              <ListItem onClick={registerApiGed}>
                <Credentials width="18px" height="18px" />
                {instance.apiGedCredentials ? 'Atualizar credenciais API GED' : 'Registrar credenciais API GED'}
              </ListItem>
            )}
            {(process.env.REACT_APP_FIREBASE_PROJECT_LABEL !== 'benner-metrics'
              && (instance.operationalStatus !== 'Cancelado'
              && !instance.disabled)
              && (userIsSupport || userIsAdmin)) && (
              <ListItem onClick={allowL1Reports}>
                <LegalOne color={theme.grey} />
                Permitir Relatórios Legal One (10 dias)
              </ListItem>
            )}
            {userIsAdmin && (
              <>
                <ListItem onClick={message}>
                  <Message />
                  Enviar Mensagem
                </ListItem>
                {instance.gptApi && (
                  <ListItem onClick={addTokens}>
                    <VirtualAssistant />
                    Adicionar tokens cortesia
                  </ListItem>
                )}
                {/* {instance.loginProvider?.length > 0 && (
                  <ListItem onClick={removePasswords}>
                    <Key />
                    Forçar uso do SSO
                  </ListItem>
                )} */}
                <ListItem onClick={blockInstance}>
                  <ClosedLock />
                  {instance.disabled ? 'Desbloquear Instância' : 'Bloquear Instância'}
                </ListItem>
                <ListItem onClick={editInstace}>
                  <Edit />
                  Editar Instância
                </ListItem>
                <ListItem onClick={deleteInstance}>
                  <Trash />
                  Apagar Instância
                </ListItem>
              </>
            )}
            {(userIsAdmin || userIsSupport) && (
              <>
                <ListItem onClick={deactivateCustomerReports}>
                  <InactivateFile width="24" height="24" />
                  Inativar relatórios
                </ListItem>
                <ListItem onClick={reactivateCustomerReports}>
                  <RestoreFile width="24" height="24" />
                  Reativar relatórios inativos
                </ListItem>
              </>
            )}
          </List>
        </Popover.Content>
      </Popover>
    );
  };

  InstanceMoreOptions.propTypes = {
    instance: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  InstanceOptions.propTypes = {
    instance: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  const getOperationalStatus = (param) => {
    let conditionalColor = 'transparent';
    switch (param.operationalStatus) {
      case 'Em implantação':
      case 'Em espera':
      case 'Atenção':
        conditionalColor = 'warning';
        break;
      case 'Suspenso':
      case 'Cancelado':
        conditionalColor = 'error';
        break;
      case 'Teste':
      case 'Comercial':
      case 'Prospecto':
        conditionalColor = 'info';
        break;
      case 'Preparado':
      case 'Operacional':
        conditionalColor = 'success';
        break;
      default:
        conditionalColor = 'info';
    }
    if (param?.operationalStatus) {
      return (
        <Badge color={conditionalColor} style={{ margin: 'auto' }}>
          {param.operationalStatus}
        </Badge>
      );
    }
    return (<>-</>);
  };

  const checkGed = (hasGedCredentials) => {
    if (hasGedCredentials) {
      return (
        <Badge size="small" color={theme.info}>
          GED
        </Badge>
      );
    }
    return null;
  };

  const toggleFilter = (field, state) => {
    setFilters((f) => ({
      ...f,
      [field]: {
        ...f[field],
        isOpen: state !== undefined ? state : !f[field].isOpen,
      },
    }));
  };

  const handleFilter = (field, selected) => {
    setFilters((f) => ({
      ...f,
      [field]: {
        ...f[field],
        selected,
        isDirty: true,
      },
    }));
  };

  const nameOptionsFilter = useMemo(() => (
    [...new Set(instances.map((inst) => inst.name))]
      .map((name) => ({
        id: name,
        label: name,
        value: name,
      }))
  ), [instances]);

  const planOptionsFilter = useMemo(() => (
    [...new Set(instances.map((inst) => inst.plan))]
      .map((plan) => ({
        id: plan,
        label: plans[plan]?.label,
        value: plan,
      }))
  ), [instances]);

  const operationalStatusOptionsFilter = useMemo(() => (
    [...new Set(instances.map((inst) => inst.operationalStatus))]
      .map((status) => {
        if (status === '' || status === undefined) {
          return {
            id: '',
            label: '-',
            value: '',
          };
        }
        return {
          id: status,
          label: status,
          value: status,
        };
      })
  ), [instances]);

  const columns = useMemo(() => [
    {
      field: 'flipper',
      label: '',
      valueGetter: (param) => (
        <IconFlipWrapper flip={param.showMoreContent}>
          <ExpandMore />
        </IconFlipWrapper>
      ),
    },
    {
      field: 'name',
      label: `Instâncias (${instances.length})`,
      sortable: true,
      valueGetter: (param) => (
        <>
          <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {param.name}
            {param?.loginProvider?.length > 0 && (
              <Tooltip text="Cliente SSO">
                <OpenIdConnect fill={theme.info} />
              </Tooltip>
            )}
          </span>
          <Ged>
            {checkGed(param.apiGedCredentials)}
          </Ged>
        </>
      ),
      tools: (
        <TableFilters
          field="name"
          isOpen={filters?.name?.isOpen || false}
          toggle={toggleFilter}
          options={nameOptionsFilter}
          selected={filters?.name?.selected || []}
          handleFilter={handleFilter}
        />
      ),
    },
    {
      field: 'plan',
      label: 'Planos',
      sortable: true,
      valueGetter: (param) => {
        const lbls = plans[param.plan]?.label?.split(' - ') ?? [''];
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <PlanLabel>{lbls[0]}</PlanLabel>
            {Boolean(lbls[1]) && (
              <PlanLabelExtra>{lbls[1]}</PlanLabelExtra>
            )}
          </div>
        );
      },
      tools: (
        <TableFilters
          field="plan"
          isOpen={filters?.plan?.isOpen || false}
          toggle={toggleFilter}
          options={planOptionsFilter}
          selected={filters?.plan?.selected || []}
          handleFilter={handleFilter}
        />
      ),
    },
    {
      field: 'disabled',
      label: 'Status',
      sortable: true,
      valueGetter: (param) => (
        <Badge color={param.disabled ? 'error' : 'success'} style={{ margin: 'auto' }}>
          {param.disabled ? 'Inativo' : 'Ativo'}
        </Badge>
      ),
      tools: (
        <TableFilters
          field="disabled"
          isOpen={filters?.disabled?.isOpen || false}
          toggle={toggleFilter}
          options={[{ id: 'status_active', label: 'Ativo', value: false }, { id: 'status_inactive', label: 'Inativo', value: true }]}
          selected={filters?.disabled?.selected || []}
          handleFilter={handleFilter}
        />
      ),
    },
    {
      field: 'operationalStatus',
      label: 'Situação',
      sortable: true,
      valueGetter: (param) => getOperationalStatus(param),
      tools: (
        <TableFilters
          field="operationalStatus"
          isOpen={filters?.operationalStatus?.isOpen || false}
          toggle={toggleFilter}
          options={operationalStatusOptionsFilter}
          selected={filters?.operationalStatus?.selected || []}
          handleFilter={handleFilter}
        />
      ),
    },
    {
      field: 'created_at',
      label: 'Data de criação',
      sortable: true,
      valueGetter: (param) => (param.created_at ? formatDateTime(`${param.created_at}`) : '-'),
    },
    {
      field: 'options',
      label: 'Opções',
      valueGetter: (param) => <InstanceOptions instance={param} />,
    },
    {
      field: 'MoreOptions',
      label: '',
      valueGetter: (param) => <InstanceMoreOptions instance={param} />,
    },
  ], [instances, filters]);

  const contentContainer = (open, extraData) => (
    <CollapsibleContainer control={open} maxSize={50}>
      <ExtraInfos>
        <ExtraItens>
          Identificador:
          <strong style={{ marginLeft: '4px' }}>
            {extraData.id || '-'}
          </strong>
        </ExtraItens>
        <ExtraItens>
          Memória:
          <Badge color="secondary" size="small">
            {extraData.volumeData || 0}
          </Badge>
        </ExtraItens>
        <ExtraItens>
          Snapshots:
          <Badge color="secondary" size="small">
            {extraData.snapshots || 0}
          </Badge>
        </ExtraItens>
        <ExtraItens>
          Super:
          <Badge color="secondary" size="small">
            {extraData.superS || 0}
          </Badge>
        </ExtraItens>
        <ExtraItens>
          Cientista:
          <Badge color="secondary" size="small">
            {extraData.scientists || 0}
          </Badge>
        </ExtraItens>
        <ExtraItens>
          Convidados:
          <Badge color="secondary" size="small">
            {extraData.guests || 0}
          </Badge>
        </ExtraItens>
      </ExtraInfos>
    </CollapsibleContainer>
  );

  useEffect(() => {
    setPage(0);
  }, [filterText]);

  useEffect(() => {
    setRowData(filteredInstances.reduce((aux, ins) => {
      if (filterText && !ins.name.toLowerCase().includes(filterText.toLocaleLowerCase())) {
        return aux;
      }
      aux.push({
        ...ins,
        moreContent: contentContainer(!!showExtra[ins.id], ins),
        showMoreContent: !!showExtra[ins.id],
        toggleMoreContent: (toggle) => handleExtraContent(toggle, ins.id),
      });
      return aux;
    }, []));
  }, [filteredInstances, showExtra, filterText]);

  return (
    <MainContainer>
      <TableOverFlow>
        <DataTable
          columns={columns}
          rowData={rowData}
          defaultSortField="name"
          defaultSortOrder="ascending"
          headerColor="transparent"
          rowColor={theme.tableBackground}
          strippedRowsColor={theme.containerOdd}
          theadStyle={{
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: theme.background,
          }}
          expandRow
          usePagination
          page={page}
          itemsPerPage={20}
        />
      </TableOverFlow>
      <TablePagination
        page={page}
        setPage={setPage}
        totalPages={Math.floor(rowData.length / 20)}
      />
    </MainContainer>
  );
};

InstanceTable.propTypes = {
  /** Array of instances data */
  instances: PropTypes.arrayOf(PropTypes.shape({})),
  /** Function to block an instance */
  handleBlock: PropTypes.func,
  /** Function to edit an instance */
  handleEdit: PropTypes.func,
  /** Function to add more AI tokens */
  handleAddTokens: PropTypes.func,
  /** Function to delete an instance */
  handleDelete: PropTypes.func,
  /** Function to add an user to instance */
  handleAddUser: PropTypes.func,
  /** Function to add an Antecipei report to the instance */
  handleAddAntecipei: PropTypes.func,
  /** Function to add a Benner report to the instance */
  handleAddBenner: PropTypes.func,
  /** Function to add the onboarding report to instance */
  handleOnboarding: PropTypes.func,
  /** Function to request the API credentials */
  handleRequestApiCredentials: PropTypes.func,
  /** Function to handle messages sent to users */
  handleMessage: PropTypes.func,
  /** Function to add the API GED Credentials of the company */
  handleApiGedRegister: PropTypes.func,
  /** Function to allow L1 reports for the instance */
  handleAllowL1Reports: PropTypes.func,
  /**
   * Function to remove the password and password login provider from the users,
   * to enforce SSO usage
   */
  handleRemovePasswords: PropTypes.func,
  /** Open a modal with the instance users */
  openUsersModal: PropTypes.func,
  /** Open a modal with the instance details */
  handleInformation: PropTypes.func,
  /** String to filter instances by name */
  filterText: PropTypes.string,
  /** Checks if the user has admin role */
  userIsAdmin: PropTypes.bool,
  /** Checks if the user has support role */
  userIsSupport: PropTypes.bool,
  /** Contract plans */
  plans: PropTypes.objectOf(PropTypes.shape({})),
};

export default InstanceTable;
